import { AlertingHistoryGrid } from './AlertingHistoryGrid';

export interface AlertingHistoryPageProps {
  stateStorageKey?: string;
}

/** Daily CE alert run log; admins may add or edit rows for backfill. */
export function AlertingHistoryPage({ stateStorageKey }: AlertingHistoryPageProps) {
  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <AlertingHistoryGrid stateStorageKey={stateStorageKey} />
      </div>
    </div>
  );
}
